(function() {
    "use strict";

    angular.module("eSign")
        .controller("SigningCompletedController", ['$scope', '$http', '$window', 'signTaskService', 'sessionService', 'appConfig', function ($scope, $http, $window, signTaskService, sessionService, appConfig) {

            $scope.completedDocuments = [];
            $scope.ExternalReference = "";
            $scope.IsPrivate = false;
            $scope.IsCorporate = false;
            $scope.isLoading = true;

            // When the user selects the completed document, it should be opened
            $scope.downloadCombinedDocument = function() {
              $window.open(signTaskService.getCombinedDocumentURL(), '_blank');
            }

            $scope.downloadDocument = function (document) {
                $window.open(signTaskService.getSignedDocumentURL(document.reference), '_blank');
            }

            var getCompletedDocuments = function () {
                signTaskService.getCompletedDocumentsForSignTask(true).then(function (response) {
                    $scope.IsPrivate = (response.data.customerType === 'PRIVATE');
                    $scope.IsCorporate = !$scope.IsPrivate;
                    $scope.completedDocuments = response.data.documents;
                    $scope.isLoading = false;

                });
            };

            var getExternalReference = function () {
                signTaskService.getExternalReference().then(function (response) {
                    $scope.ExternalReference = response.data;
                    getCompletedDocuments();
                });
            };

            // Start of the page by fetching
            getExternalReference();
        }]);
}());
